import React from "react";
import {LocationOff as CommunicationLocationOff} from "@material-ui/icons";
import {Panel} from "../../components/Panel";
import noty from "../../lib/noty";
import FieldImage from "../../components/FieldImage";
import FieldSelect from "../../components/FieldSelect";
import Field from "../../components/Field";
import HelpText from "../../components/HelpText";

const IconPreview = props => {
  const image = props.src ? (
    <img alt={props.name} src={props.src} />
  ) : (
    <React.Fragment>
      <CommunicationLocationOff color="disabled" />
      <p className="text-muted">No image chosen</p>
    </React.Fragment>
  );

  return (
    <div id="iconPreview">
      <label className="field-label"> Icon Preview </label>
      {image}
    </div>
  );
};

export default class MarkerTypePanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      touched: false,
      markerType: this.props.markerType
    };
  }

  render() {
    const {markerType, fetching, touched} = this.state;
    const {categoryOptions} = this.props;
    return (
      <Panel
        checkCanAdd="marker-types"
        onSaveClick={this.handleSubmit}
        saveTitle={markerType._id ? "Save Marker Type" : "Create Marker Type"}
        onDeleteClick={markerType._id && this.handleRemove}
        fetching={fetching}
        touched={touched}
        touchedMessage="Are you sure that you want to leave? This building has unsaved changes.">
        <div id="icon">
          <Field
            name="name"
            value={markerType.name}
            onChange={this.handleChange}
            label="Marker Type Name"
            disabled={fetching}
          />
          <IconPreview name={markerType.name} src={markerType.image.path} />
        </div>
        <FieldImage
          value={markerType.image}
          name="image"
          onChange={this.handleChange}
          label="Marker Type Icon"
          disabled={fetching}
        />
        <FieldSelect
          name="category_id"
          value={markerType.category_id}
          onChange={this.handleChange}
          label="Marker Type Category"
          options={categoryOptions}
          disabled={fetching}
        />
        <p className="text-muted">
          Marker images are best uploaded at 40px x 40px. Upload a new image and view the preview of your marker above.
        </p>
        <HelpText
          href="https://mapplug.zendesk.com/hc/en-us/articles/360008924193-Creating-custom-marker-types"
          description="Need help? See our guide on creating a custom marker type."
        />
      </Panel>
    );
  }

  handleChange = ({name, value}) => {
    const path = name.split(".");
    this.setState({
      touched: true,
      markerType: this.state.markerType.setIn(path, value)
    });
  };

  handleSubmit = () => {
    const {markerType} = this.state;
    const method = markerType._id ? "patch" : "create";
    this.setState({fetching: true});
    markerType[method]()
      .then(() => {
        this.setState({fetching: false, touched: false});
        noty.success(markerType._id ? "Marker Type Updated" : "Marker Type Created");
      })
      .catch(err => {
        this.setState({fetching: false});
        noty.errors(err);
      });
  };

  handleRemove = () => {
    const {markerType} = this.state;
    noty.confirm(`Are you sure you want to delete "${markerType.name}"`, {
      onOk: () => {
        this.setState({fetching: true});
        markerType
          .remove()
          .then(() => {
            noty.success("Marker Type removed.");
          })
          .catch(err => {
            this.setState({fetching: false});
            noty.errors(err);
          });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/MarkerTypePanel/index.jsx